<article id="main">
  <router-outlet></router-outlet>
</article>
